import CloseIcon from '@mui/icons-material/Close';
import {IconButton, SxProps} from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';

export interface Props {
    onCloseClick: () => void;
    disabled?: boolean;
    sx?: SxProps;
}

export const Component = (p: Props) => {
    return (
        <Box
            sx={{
                boxSizing: 'border-box',
                height: '44px',
                width: '100%',
                display: 'flex',
                padding: '8px',
                justifyContent: 'flex-end',
                alignItems: 'center',
                ...p.sx
            }}
        >
            <IconButton onClick={p.onCloseClick} size="small" color="secondary" disabled={p.disabled}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </Box>
    );
};

Component.displayName = 'CloseBar';
